import axiosInstance from "../axios/axios-instance";
import {
    SalonServiceApiResponse,
    SalonServiceAutoTranslateApiResponse,
    SalonServiceUpdatePayload,
    SalonServiceTranslationPayload,
    SalonServiceTranslationsApiResponse,
    SalonServicesApiResponse,
    SalonStylistOptionsApiResponse,
} from "../@type/salonService.types";
import { pathAPI } from "../utils/pathApi";

export const SalonAPI = {
    createSalon: (data: SalonRegistration) => {
        return axiosInstance.post(`${pathAPI.salons}`, data);
      },
    updateSalonInfo: (id: string, data: SalonInfo) => {
        return axiosInstance.put(`${pathAPI.salons}/${id}`, data);
      },
    getSalonInfo: (id: string) => {
        return axiosInstance.get(`${pathAPI.salons}/${id}/info`);
      },
    getSalonSetting: (id: string) => {
        return axiosInstance.get(`${pathAPI.salons}/${id}/settings`);
      },
    getPhotoLimit: () => {
        return axiosInstance.get(`${pathAPI.salons}/photo-limit`);
      },
    getSalonPhoto: (id: string) => {
        return axiosInstance.get(`${pathAPI.salons}/${id}/photos`);
      },
    updateSalonPhoto: (id: string, data: PhotosSalon) => {
        return axiosInstance.put(`${pathAPI.salons}/${id}/photos/featured`, data);
      },
    updateSalonSetting: (id: string, data: SalonSetting) => {
        return axiosInstance.put(`${pathAPI.salons}/${id}/settings`, data);
      },
    getSalonServices: (outletId: string | number) => {
        return axiosInstance.get<SalonServicesApiResponse>(
            `${pathAPI.salons}/${outletId}/services`
        );
      },
    getSalonStylists: (outletId: string | number) => {
        return axiosInstance.get<SalonStylistOptionsApiResponse>(
            `${pathAPI.salons}/${outletId}/stylists`
        );
      },
    updateSalonService: (
        outletId: string | number,
        serviceId: string | number,
        data: SalonServiceUpdatePayload
    ) => {
        return axiosInstance.put<SalonServiceApiResponse>(
            `${pathAPI.salons}/${outletId}/services/${serviceId}`,
            data
        );
      },
    getServiceTranslations: (outletId: string | number, serviceId: string | number) => {
        return axiosInstance.get<SalonServiceTranslationsApiResponse>(
            `${pathAPI.salons}/${outletId}/services/${serviceId}/translations`
        );
      },
    saveServiceTranslations: (
        outletId: string | number,
        serviceId: string | number,
        data: SalonServiceTranslationPayload[]
    ) => {
        return axiosInstance.put<SalonServiceTranslationsApiResponse>(
            `${pathAPI.salons}/${outletId}/services/${serviceId}/translations`,
            data
        );
      },
    autoTranslateServiceName: (
        outletId: string | number,
        data: { text: string; source_language_code: string }
    ) => {
        return axiosInstance.post<SalonServiceAutoTranslateApiResponse>(
            `${pathAPI.salons}/${outletId}/services/translations/auto`,
            data
        );
      },
}
